export default {
  title: {
    en: 'Review recent billing',
  },
  billingProblem: {
    en: '<strong>If there is a problem</strong> with your billing, please let us know the details and we’ll give you a <strong>free month.</strong>',
  },
  report: {
    en: 'Report, this billing is wrong',
  },
}
